module.exports = __webpack_public_path__ + "static/img/DZ@3x.dd2e0b63.jpg";